module.exports = {
  none: "None",
  all: "All",
  without: "Without"

}


// WEBPACK FOOTER //
// ../i18n/en/multiSelect.js